function snakeToCamelKey(value: string): string {
  return value.replace(/_([a-z])/g, (_, letter: string) => letter.toUpperCase())
}

function camelToSnakeKey(value: string): string {
  return value.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`)
}

export function fromApi<T>(value: unknown): T {
  if (Array.isArray(value)) {
    return value.map((item) => fromApi(item)) as T
  }

  if (value && typeof value === "object" && !(value instanceof Date)) {
    const transformed = Object.entries(value as Record<string, unknown>).reduce<
      Record<string, unknown>
    >((accumulator, [key, entry]) => {
      accumulator[snakeToCamelKey(key)] = fromApi(entry)
      return accumulator
    }, {})

    return transformed as T
  }

  return value as T
}

export function toApi<T>(value: unknown): T {
  if (Array.isArray(value)) {
    return value.map((item) => toApi(item)) as T
  }

  if (value && typeof value === "object" && !(value instanceof Date)) {
    const transformed = Object.entries(value as Record<string, unknown>).reduce<
      Record<string, unknown>
    >((accumulator, [key, entry]) => {
      accumulator[camelToSnakeKey(key)] = toApi(entry)
      return accumulator
    }, {})

    return transformed as T
  }

  return value as T
}
